import { render, staticRenderFns } from "./EditSchema.vue?vue&type=template&id=0924ebc4&"
import script from "./EditSchema.vue?vue&type=script&lang=js&"
export * from "./EditSchema.vue?vue&type=script&lang=js&"
import style0 from "./EditSchema.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports